<div
  class="player-controls"
  [class.player-controls--mob-lg]="showMobLgView"
  [class.player-controls--mob-sm]="showMobSmView"
>
  <!-- Shuffle button -->
  @if (showShuffleBtn) {
    <span
      class="player-controls__item"
      [class.player-controls__item--inactive]="!isShuffleActive"
      (click)="onShuffleClick()"
    >
      <bmcore-shuffle-icon [width]="showMobLgView ? 24 : 16" [height]="showMobLgView ? 24 : 16"> </bmcore-shuffle-icon>
    </span>
  }

  <div class="player-controls__main-controls">
    <!-- Prev track button -->
    <span class="player-controls__item theme-player__btnNextPrev" (click)="onPlayPrevClick($event)">
      <bmcore-skip-back-icon
        [width]="showMobLgView ? 36 : 24"
        [height]="showMobLgView ? 36 : 24"
      ></bmcore-skip-back-icon>
    </span>

    <!-- Play / pause track button -->
    <span class="player-controls__item" (click)="onPlayPauseClick($event)">
      <ng-container>
        @if (player.status !== PlayStatus.Playing) {
          <bmcore-play-icon [width]="showMobLgView ? 48 : 32" [height]="showMobLgView ? 48 : 32"></bmcore-play-icon>
        }

        @if (player.status === PlayStatus.Playing) {
          <bmcore-pause-icon [width]="showMobLgView ? 48 : 32" [height]="showMobLgView ? 48 : 32"></bmcore-pause-icon>
        }
      </ng-container>
    </span>

    <!-- Next track button -->
    <span class="player-controls__item theme-player__btnNextPrev" (click)="onPlayNextClick($event)">
      <bmcore-skip-forward-icon
        [width]="showMobLgView ? 36 : 24"
        [height]="showMobLgView ? 36 : 24"
      ></bmcore-skip-forward-icon>
    </span>
  </div>

  <!-- Repeat mode button -->
  @if (showRepeatBtn) {
    <span
      class="player-controls__item"
      [class.player-controls__item--inactive]="repeatMode === 'off'"
      (click)="onRepeatClick()"
    >
      @switch (repeatMode) {
        @case ('one') {
          <bmcore-repeat-one-icon
            [width]="showMobLgView ? 24 : 16"
            [height]="showMobLgView ? 24 : 16"
          ></bmcore-repeat-one-icon>
        }
        @default {
          <bmcore-repeat-icon [width]="showMobLgView ? 24 : 16" [height]="showMobLgView ? 24 : 16"></bmcore-repeat-icon>
        }
      }
    </span>
  }
</div>
